import { motion, Variants } from 'framer-motion';
import React, { PropsWithChildren } from 'react';

const animationConfiguration: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

const Transitions: React.FC<PropsWithChildren> = (props) => {
  return (
    <motion.div
      variants={animationConfiguration}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2 }}
    >
      {props.children}
    </motion.div>
  );
};
export default Transitions;
